import { Component, Input } from '@angular/core';
import { DashService } from '@modules/dash-board/dash.service';

@Component({
  selector: 'app-custom-popup-modal',
  templateUrl: './custom-popup-modal.component.html',
  styleUrls: ['./custom-popup-modal.component.scss'],
})
export class CustomPopupModalComponent {
  @Input() isVisible: boolean = false;

  constructor(private dash: DashService) {}

  mobToggle = false;

  public officeName = null;
  ngOnInit(): void {
    this.dash?.screenSize$?.subscribe(size => {
      if (size.width < 768) {
        this.mobToggle = true;
      } else {
        this.mobToggle = false;
      }
    });
  }
}
